import {
  Header1,
  Instruction,
  InstructionWithContent,
  InstructionWithImage,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TextareaLine,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_12_2_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),
  InstructionWithImage("typography_3", "0"),

  Header1("typography_4"),
  Instruction("typography_5"),
  Instruction("typography_6"),

  InstructionWithContent(`typography_7`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 팀장님이 나를 불렀다. 나는 내가 무엇을 잘못했는지 계속 고민했다. 아마 어제 제출한 보고서 때문인 것 같은데, 왜 나는 항상 이렇게 실수를 반복할까. 정말 답답하다. 다음부터는 그러지 말아야지. 그런데 맨날 이렇게 다짐해도 똑같잖아. 회사 관두고 싶다.",
          },
          {
            text: "B. 보고서에 또 실수를 한 게 틀림없어. 이번에는 진짜 크게 혼나겠구나.",
          },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_8"),

  Header1("typography_9"),
  Instruction("typography_10"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 차가 막혀서 늦을 수도 있는데 내가 너무 예민하게 굴었네.",
          },
          { text: "B. 나를 무시하는 건가? 어떻게 이렇게 매번 늦지?" },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_13"),

  Header1("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),

  InstructionWithContent(`typography_18`, [
    [
      ButtonGroup(
        [
          { text: "A. 그 사람이 나를 싫어한다고 생각했다." },
          { text: "B. 나를 피하는 게 분명해. 내가 어제 실수해서 그런 걸까?" },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_19"),

  Header1("typography_20"),
  InstructionWithContent(`typography_21`, [
    ...LineWithSolidLabel("원칙 1", TypographyLine("typography_principle_1")),
    ...LineWithSolidLabel("원칙 2", TypographyLine("typography_principle_2")),
    ...LineWithSolidLabel("원칙 3", TypographyLine("typography_principle_3")),
  ]),

  Instruction("typography_practice_intro"),

  InstructionWithContent(`typography_22`, [
    ...LineWithSolidLabel("상황", TextareaLine({ id: "상황" })),
  ]),
  Instruction("typography_23"),
  InstructionWithContent(`typography_24`, [
    ...LineWithSolidLabel("생각", TextareaLine({ id: "생각" })),
  ]),
  Instruction("typography_25"),

  ...LastCard,
];
